var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstantBonus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_730_4274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.8408 68.2747C83.4596 52.6559 83.4596 27.3329 67.8408 11.7141C52.2221 -3.90466 26.899 -3.90466 11.2803 11.7141C-4.33849 27.3329 -4.33849 52.6559 11.2803 68.2747C26.899 83.8934 52.2221 83.8934 67.8408 68.2747Z",
    fill: "url(#paint0_linear_730_4274)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_730_4274)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7002 23.42C41.4702 23.42 42.9102 21.98 42.9102 20.21C42.9102 18.44 41.4702 17 39.7002 17C37.9302 17 36.4902 18.44 36.4902 20.21C36.4902 21.98 37.9302 23.42 39.7002 23.42Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5392 48.19C30.4592 48.18 30.3892 48.16 30.3192 48.13C29.9592 47.98 29.6992 47.62 29.6992 47.21",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6992 47.2001V43.8601",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7014 43.8601C27.6814 42.5401 26.1714 40.7101 25.4414 38.6101",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4398 38.6101H23.8398",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8409 38.6099C23.3109 38.6099 22.8809 38.1799 22.8809 37.6499",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8809 37.6501V34.0601",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8809 34.0601C22.8809 33.5301 23.3109 33.1001 23.8409 33.1001",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8398 33.1001H25.3798",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3809 33.1C25.9809 31.24 27.1909 29.58 28.8309 28.29",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8313 28.29C27.5013 28.41 26.2413 26.79 25.0312 24.19C27.7613 23.41 30.2013 23.81 32.0813 26.44",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.0703,
    cy: 26.4399,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0703 26.44C33.6903 25.8 35.4903 25.45 37.4003 25.45C44.2703 25.45 49.8403 30.07 49.8403 35.77C49.8403 39.32 47.6803 42.4399 44.3903 44.2999",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4004 44.29V46.83",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4614 48.37C38.9114 48.37 38.4414 47.76 38.4414 47.21",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4492 47.2V46.04",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4499 46.04C38.1099 46.06 37.7599 46.08 37.4099 46.08C36.8199 46.08 36.2399 46.04 35.6699 45.98",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6602 45.97V47.2",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6597 47.2C35.6597 47.66 35.3497 48.04 34.9297 48.16",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8809 45.99H64.9309",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9297 45.99C65.8197 45.99 66.5497 46.72 66.5497 47.61",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5391 47.6101V61.3701",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5399 61.3701C66.5399 62.2601 65.8099 62.9901 64.9199 62.9901",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9309 62.99H62.8809",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8798 62.9901C61.9898 62.9901 61.2598 62.2601 61.2598 61.3701",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2695 61.3701V47.6101",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2695 47.61C61.2695 46.72 61.9995 45.99 62.8895 45.99",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9991 43.18C14.3791 41.51 11.8491 42.59 13.5391 45.33C15.6591 48.78 31.7791 59.88 35.8191 62.68C41.2791 66.37 50.6091 58.82 61.2591 59.45",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2695 59.4601V47.6101",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2702 47.6099C56.1802 47.3599 52.1902 42.4599 48.2902 44.7399C43.7802 47.2899 40.4902 49.2199 34.9102 48.1699",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9092 48.1699C29.6992 45.9899 26.5392 51.5299 31.0392 53.8599C34.1492 55.3899 37.1692 54.7999 40.0592 55.0299C45.0792 55.4299 49.3492 55.3299 51.4592 53.3899",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 43.1799L28.89 50.6899",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.25 28.2601C37.16 27.8001 39.33 27.8801 41.3 28.4801",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2491 34.26C30.8691 34.26 31.3791 33.75 31.3791 33.13C31.3791 32.51 30.8691 32 30.2491 32C29.6291 32 29.1191 32.51 29.1191 33.13C29.1191 33.75 29.6291 34.26 30.2491 34.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7188 34.37C52.3488 35.37 54.2387 32.92 52.8387 31.13C52.1987 30.4 51.1888 30.41 50.8988 31.17",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_730_4274",
    x1: 11.2803,
    y1: 11.7141,
    x2: 67.8408,
    y2: 68.2747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D008B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A3E0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_730_4274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_730_4274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.54,
    height: 48.71,
    fill: "white",
    transform: "translate(12 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstantBonus);
export default __webpack_public_path__ + "static/media/instant-bonus.2ff6d5007f2f0403b06cd3447f4b22ce.svg";
export { ForwardRef as ReactComponent };